import { createBrowserRouter } from 'react-router';
import { AppAuthProvider } from '../components/loginSignup/AppAuthProvider';
import PageLayout from '../components/PageLayout';
import { publicRoutes } from './routes/publicRoutes';
import { AuthenticatedLayout } from './layouts/AuthenticatedLayout';
import { ChatLayout } from './layouts/ChatLayout';
import { appRoutes } from './routes/appRoutes';
import { errorRoutes } from './routes/errorRoutes';

export const AppRouter = createBrowserRouter([
  {
    path: '/',
    element: (
      <AppAuthProvider>
        <PageLayout />
      </AppAuthProvider>
    ),
    children: [
      ...publicRoutes,
      {
        element: <AuthenticatedLayout />,
        children: [
          {
            element: <ChatLayout />,
            children: [...appRoutes],
          },
        ],
      },
            
      ...errorRoutes
    ]
  }
]);
